// extracted by mini-css-extract-plugin
module.exports = {"eidtor":"eidtor--2DBBI","iconWrap":"iconWrap--1J0rW","icon":"icon--3fBc_","selectWrap":"selectWrap--1rmhG","operator":"operator--1ty9d","aside":"aside--1ZFC_"};